export default __webpack_public_path__ + "static/media/Group9172.285dadcb.svg";